<template>
  <div class="password-new-wrapper">
    <div class="password-new-page container">
      <div class="login-header">
        <div class="logo">
          <img src="@/assets/logo.svg" />
        </div>
        <div class="tiles">
          <span class="tile back-olive"></span>
          <span class="tile back-black"></span>
          <span class="tile back-green"></span>
          <span class="tile back-off-green"></span>
        </div>
      </div>

      <div class="container px-4">
        <h1 class="is-size-1 mr-5">{{ $t("password-reset.title") }}</h1>
        <div v-if="!changed">
          <p class="mb-4">{{ $t("password-new.description.text") }}</p>
          <form action="#" method="post" @submit.prevent="submit">
            <div class="field mb-4">
              <div class="control">
                <label>{{ $t("login.labels.password") }}</label>
                <input
                  v-model="password"
                  class="input"
                  type="password"
                  required
                  :placeholder="$t('login.placeholder.password')"
                  autofocus
                />
                <ul v-if="errors.password" class="help is-warning mt-2">
                  <li v-for="(error, index) in errors.password" :key="index">
                    {{ error }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="field mb-4">
              <div class="control">
                <label>{{ $t("password-new.labels.password_repeat") }}</label>
                <input
                  v-model="passwordRepeat"
                  class="input"
                  type="password"
                  required
                  :placeholder="$t('password-new.labels.password_repeat')"
                  autofocus
                />
                <ul v-if="errors.passwordRepeat" class="help is-warning mt-2">
                  <li v-for="(error, index) in errors.passwordRepeat" :key="index">
                    {{ error }}
                  </li>
                </ul>
              </div>
            </div>

            <span
              v-if="errors['token']"
              class="has-text-warning has-text-weight-semibold"
            >
              {{ errors["token"][0] }}
            </span>

            <span
              v-if="errors['non_field_errors']"
              class="has-text-warning has-text-weight-semibold"
            >
              {{ errors["non_field_errors"][0] }}
            </span>

            <button type="submit" class="button is-fullwidth">
              {{ $t("password-new.label.submit") }}
            </button>
          </form>
        </div>
        <div v-if="changed">
          <p class="mb-4">{{ $t("password-new.ok") }}</p>
          <router-link to="/">
            <span>{{ $t("password-new.return-link") }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api"
import { mapMutations } from "vuex"

export default {
  name: "password-new",
  data() {
    return {
      password: "",
      passwordRepeat: "",
      errors: {},
      result: {},
      changed: false,
    }
  },
  computed: {
    token() {
      return this.$route.params.token
    },
  },
  methods: {
    ...mapMutations(["windowOpen"]),
    submit: async function () {
      this.errors = {}
      api
        .setNewPassword(this.token, this.password, this.passwordRepeat)
        .then((response) => {
          this.result = response.data
          this.changed = true
        })
        .catch((error) => {
          this.errors = error.response ? error.response.data : {}
        })
    },
  },
}
</script>
